export default __webpack_public_path__ + "static/media/victoria_lansdale.c9da85e5.gif";